module.exports = __webpack_public_path__ + "static/media/accountIcon.2f425d85.svg";